import React from "react";

export default function ColorFrame9({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <ellipse
          cx="63.7591"
          cy="228.759"
          rx="5.57705"
          ry="24.3362"
          fill="#E5F0FF"
        />
        <circle cx="63.759" cy="258.672" r="7.60507" fill="#8859C2" />
        <ellipse
          rx="5.57705"
          ry="24.3362"
          transform="matrix(-0.696978 0.717092 0.717092 0.696978 236.077 170.053)"
          fill="#E5F0FF"
        />
        <circle
          r="7.60507"
          transform="matrix(-0.696978 0.717092 0.717092 0.696978 257.528 190.902)"
          fill="#8859C2"
        />
        <ellipse
          rx="5.57705"
          ry="24.3362"
          transform="matrix(-0.914559 0.404453 0.404453 0.914559 165.987 226.399)"
          fill="#E5F0FF"
        />
        <circle
          r="7.60507"
          transform="matrix(-0.914559 0.404453 0.404453 0.914559 178.085 253.756)"
          fill="#8859C2"
        />
        <path
          d="M252.238 124.063C267.282 152.305 223.074 211.474 166.587 230.896C96.8373 254.879 19.4071 229.914 14.9601 205.183C10.5131 180.453 57.3339 151.78 122.738 129.291C188.143 106.803 244.28 109.122 252.238 124.063Z"
          fill="#7A6FF7"
        />
        <path
          d="M248.309 116.203C263.352 144.446 213.741 201.512 159.71 220.09C96.8372 241.708 14.533 216.801 11.0306 197.324C7.52815 177.847 53.4043 143.92 118.809 121.432C184.213 98.9435 242.16 104.659 248.309 116.203Z"
          fill="#AA80F9"
        />
        <path
          d="M23.9205 94.8355C23.9205 45.734 63.725 5.92946 112.827 5.92946C161.928 5.92946 201.733 45.734 201.733 94.8355C201.733 143.937 161.928 183.742 112.827 183.742C63.725 183.742 23.9205 143.937 23.9205 94.8355Z"
          fill="white"
          stroke="#E5F0FF"
          strokeWidth="7.8591"
        />
        <circle cx="221.944" cy="127.833" r="3.54903" fill="#FFC444" />
        <circle cx="208.541" cy="160.06" r="3.54903" fill="#FFC444" />
        <circle cx="177.075" cy="190.196" r="3.54903" fill="#FFC444" />
        <circle cx="130.684" cy="205.374" r="3.54903" fill="#FFC444" />
        <circle cx="84.1657" cy="204.518" r="3.54903" fill="#FFC444" />
        <circle cx="43.6054" cy="190.607" r="3.54903" fill="#FFC444" />
        {children}
      </g>
    </svg>
  );
}
